/**
 * Monta o payload compartilhado para criar/editar cadernos de questões
 * (provas e simulados).
 *
 * @param {object} formValues - Valores do formulário Formik.
 * @param {object} [opts]
 * @param {string} [opts.visibility] - Override de visibility (ex.: 'exam', 'open').
 * @returns {object} Payload pronto para enviar via client.mutate().
 */
export function buildQuestionBookPayload(formValues, { visibility } = {}) {
  const aux = { ...formValues };

  // Taxonomias
  aux['taxonomy-ids'] = (aux.selectedTaxonomies || []).map(t => t.id);
  delete aux.selectedTaxonomies;

  // Learning systems — normalizar para array de IDs
  if (aux['learning-system-ids']) {
    aux['learning-system-ids'] = (Array.isArray(aux['learning-system-ids']) ? aux['learning-system-ids'] : [aux['learning-system-ids']]).map(item => (typeof item === 'object' && item !== null ? item.value : item));
  }

  // Cursos — normalizar para array de IDs
  if (aux['course-ids']) {
    aux['course-ids'] = (Array.isArray(aux['course-ids']) ? aux['course-ids'] : [aux['course-ids']]).map(item => (typeof item === 'object' && item !== null ? item.value : item));
  } else if (aux.courseId) {
    aux['course-ids'] = aux.courseId;
    delete aux.courseId;
  }

  // Turmas + datas de início/término

  const { evaluationStart, evaluationEnd } = aux;
  if (evaluationStart) {
    aux['published-at'] = `${evaluationStart.date} ${evaluationStart.hour}:${evaluationStart.minute}`;
  }
  if (evaluationEnd) {
    aux['finished-at'] = `${evaluationEnd.date} ${evaluationEnd.hour}:${evaluationEnd.minute}`;
  }

  delete aux.evaluationStart;
  delete aux.evaluationEnd;
  delete aux.association;

  if (visibility !== undefined) {
    aux.visibility = visibility;
  }

  return aux;
}
